// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"KJ-z","loadingMedia":"LJ-z","reviewsImagesAndVideos":"MJ-z","limitHeight":"NJ-z"};